// extracted by mini-css-extract-plugin
export const checkmark = "circle-checkmark-module--checkmark--2pP8r";